import * as React from 'react';
import { InformationalTooltip } from 'components/InformationalTooltip';
import { PresetView, usePreset } from '../types';

interface Props {
  presetView: PresetView;
}

export const HelpTooltip: React.FC<Props> = (props) => {
  const { presetView } = props;
  const { tooltip } = usePreset(presetView);
  return <InformationalTooltip>{tooltip}</InformationalTooltip>;
};
HelpTooltip.displayName = 'Shipments.Containers.Header.HelpTooltip';
